<div class="container-fluid bg-lightblue">
    <div class="container-xxxl">
        <div class="py-5 py-lg-4">
            <div class="row align-items-stretch my-0 my-lg-5 py-lg-2">
                <div class="col-lg-4 d-flex mb-4 mb-lg-0 d-print-none">
                    <div class="ratio ratio-16x9 flex-fill h-100 overflow-hidden rounded-3">
                        <img class="object-fit-cover" [src]="imageUrl" [alt]="article.images[0]?.altText" />
                    </div>
                </div>

                <div class="col-lg-7 offset-lg-1">
                    <div class="container-fluid pb-32">
                        <div class="row">
                            <h2 class="section-heading text-blue border-blue">{{ article.title }}</h2>
                        </div>
                    </div>
                    <div class="fs-md-18 bodyText text-link" [innerHTML]="article.bodyText"></div>
                </div>
            </div>
        </div>
    </div>
</div>
